import { Box } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';

import { presenceApi } from 'apis/presence';
import { FavoritesPresenceListSection } from 'components/presence/components/favoritesPresenceListSection';
import { LegacyPresenceListSections } from 'components/presence/components/legacyPresenceListSections';
import { PresenceSectionWarning } from 'components/presence/components/presenceSectionWarning';
import { TeamPresenceListSections } from 'components/presence/components/teamPresenceListSections';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import type { PresenceStateT } from '../reducers/presence';

import styles from './presenceList.module.scss';

type PresenceListProps = {
  presence: PresenceStateT;
  profile: User;
  favouriteTeamMemberIds: string[];
};

export const PresenceList = ({
  presence,
  profile,
  favouriteTeamMemberIds,
}: PresenceListProps): JSX.Element => {
  const flags = useFeatureFlag([
    'custom-away-status',
    'legacy-presence-sidebar',
  ]);

  const { awayStatuses } = presenceApi.useReadAwayStatusesQuery(
    { isDeactivated: false },
    {
      skip: !flags.customAwayStatus,
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        awayStatuses: data?.data.customAwayStatuses ?? [],
      }),
    },
  );

  const isOffline = presence.meta.offline;
  const hasFailed =
    presence.allPresence.length === 0 &&
    presence.meta.getAsyncStatus === 'failed';

  return (
    <Box padding="0 200">
      <ul className={styles.list}>
        {hasFailed ? (
          <PresenceSectionWarning title="Presence loading failed.." />
        ) : isOffline ? (
          <PresenceSectionWarning title="You are offline" />
        ) : flags.legacyPresenceSidebar ? (
          <LegacyPresenceListSections
            presence={presence}
            presenceAsyncStatus={presence.meta.getAsyncStatus}
            profile={profile}
            awayStatuses={awayStatuses}
          />
        ) : (
          <>
            <FavoritesPresenceListSection
              presence={presence}
              presenceAsyncStatus={presence.meta.getAsyncStatus}
              profile={profile}
              awayStatuses={awayStatuses}
              favouriteTeamMemberIds={favouriteTeamMemberIds}
            />
            <TeamPresenceListSections
              presence={presence}
              presenceAsyncStatus={presence.meta.getAsyncStatus}
              profile={profile}
              awayStatuses={awayStatuses}
            />
          </>
        )}
      </ul>
    </Box>
  );
};
